import { useEffect, useState } from "react";
import { getAuditByProject } from "./../../../services/api/qa/auditService";
import AuditFilters from "./components/AuditFilters";
import AuditTable from "./components/AuditTable";

function ProjectAuditPage({ project }) {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);

  useEffect(() => {
    fetchLogs();
  }, [project]);

  const fetchLogs = async () => {
    try {
      const logsArray = await getAuditByProject(project.id); // pass project.id
      console.log("Fetched audit logs:", logsArray);
      setLogs(logsArray);
      setFilteredLogs(logsArray);
    } catch (err) {
      console.error("Failed to load audit logs", err);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4 capitalize">
        {project?.name || "Project"} Audit Logs
      </h2>

      <AuditFilters logs={logs} setFilteredLogs={setFilteredLogs} />

      <AuditTable logs={filteredLogs} />
    </div>
  );
}

export default ProjectAuditPage;